var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.66701L5.58333 5.66699C4.42035 5.667 3.83886 5.667 3.3657 5.81053C2.30037 6.13371 1.4667 6.96738 1.14354 8.0327C1 8.50587 1 9.08736 1 10.2503V12.0003C1 13.8672 1 14.8006 1.36331 15.5136C1.68289 16.1408 2.19282 16.6508 2.82003 16.9704C3.53307 17.3337 4.46649 17.3337 6.33333 17.3337H12.3333C14.2002 17.3337 15.1336 17.3337 15.8466 16.9704C16.4738 16.6508 16.9838 16.1409 17.3034 15.5136C17.6667 14.8006 17.6667 13.8672 17.6667 12.0003V10.2503C17.6667 9.08736 17.6667 8.50587 17.5231 8.0327C17.2 6.96738 16.3663 6.13371 15.301 5.81054C14.8278 5.667 14.2463 5.667 13.0833 5.66699L12.6667 5.66701M9.33333 0.666992V13.167M9.33333 13.167L12.6667 9.83366M9.33333 13.167L6 9.83366",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export default ForwardRef;